var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandAlone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73047 22.31V48.06C6.73047 49.68 8.05047 51 9.67047 51H33.5905C35.2105 51 36.5305 49.68 36.5305 48.06V22.31C36.5305 20.69 35.2105 19.37 33.5905 19.37H9.67047C8.05047 19.37 6.73047 20.68 6.73047 22.31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5305 44.5V22.31C36.5305 20.68 35.2105 19.36 33.5805 19.36H9.68047C8.05047 19.36 6.73047 20.68 6.73047 22.31V48.05C6.73047 49.68 8.05047 51 9.68047 51H24.6605",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9106 38.01H21.6306V51H14.3906V39.53C14.3906 38.69 15.0706 38.01 15.9106 38.01Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3509 38.01H21.6309V51H25.5409C27.3809 51 28.8709 49.51 28.8709 47.67V39.53C28.8709 38.69 28.1909 38.01 27.3509 38.01Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9106 38.01H21.6306V51H14.3906V39.53C14.3906 38.69 15.0706 38.01 15.9106 38.01Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3509 38.01H21.6309V51H25.5309C27.3709 51 28.8709 49.51 28.8709 47.66V39.52C28.8709 38.69 28.1909 38.01 27.3509 38.01Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1495 31.7799H12.5195",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1495 26.45H12.5195",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 31.7799H30.7394",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 26.45H30.7394",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1097 42.59V47.42L40.7697 50.78L32.6797 51V44.5L36.5297 44.14L39.1097 42.59Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7101 28.7C44.5801 28.7 44.4601 28.71 44.3401 28.73C44.0401 22.68 39.5201 19.03 33.9901 19.03C28.4601 19.03 23.9401 22.68 23.6401 28.73C23.5201 28.71 23.3901 28.7 23.2701 28.7C21.6501 28.7 20.3301 30.02 20.3301 31.64C20.3301 33.26 21.6501 34.58 23.2701 34.58C23.6701 34.58 24.0401 34.5 24.3901 34.36C25.9301 39.76 29.6501 45.14 34.0001 45.14C38.3501 45.14 42.0701 39.76 43.6101 34.36C43.9501 34.5 44.3301 34.58 44.7301 34.58C46.3501 34.58 47.6701 33.26 47.6701 31.64C47.6501 30.01 46.3401 28.7 44.7101 28.7Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7101 28.7C44.5801 28.7 44.4601 28.71 44.3401 28.73C44.0401 22.68 39.5201 19.03 33.9901 19.03C28.4601 19.03 23.9401 22.68 23.6401 28.73C23.5201 28.71 23.3901 28.7 23.2701 28.7C21.6501 28.7 20.3301 30.02 20.3301 31.64C20.3301 33.26 21.6501 34.58 23.2701 34.58C23.6701 34.58 24.0401 34.5 24.3901 34.36C25.9301 39.76 29.6501 45.14 34.0001 45.14C38.3501 45.14 42.0701 39.76 43.6101 34.36C43.9501 34.5 44.3301 34.58 44.7301 34.58C46.3501 34.58 47.6701 33.26 47.6701 31.64C47.6501 30.01 46.3401 28.7 44.7101 28.7Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8604 42.5901V47.4201C28.8604 49.3901 27.2604 51.0001 25.2804 51.0001H24.6504",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1102 42.5901V47.4201C39.1102 49.3901 40.7102 51.0001 42.6902 51.0001H43.3202H23.7402",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9712 25.38C31.7036 25.38 37.1613 19.9224 37.1613 13.19C37.1613 6.45765 31.7036 1 24.9712 1C18.2389 1 12.7812 6.45765 12.7812 13.19C12.7812 19.9224 18.2389 25.38 24.9712 25.38Z",
    fill: "#FFCF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9712 25.38C31.7036 25.38 37.1613 19.9224 37.1613 13.19C37.1613 6.45765 31.7036 1 24.9712 1C18.2389 1 12.7812 6.45765 12.7812 13.19C12.7812 19.9224 18.2389 25.38 24.9712 25.38Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5411 15.52C30.5211 15.28 30.4411 14.95 30.3011 14.54C30.1611 14.13 29.9511 13.77 29.6911 13.48C29.4211 13.19 29.0211 12.88 28.4911 12.56C27.9611 12.24 27.3211 11.98 26.5711 11.78L25.9611 11.62V8.02005C26.2411 8.10005 26.4911 8.26005 26.7111 8.52005C27.0311 8.90005 27.2011 9.35005 27.2111 9.89005H30.0611C29.9811 8.58005 29.5311 7.57005 28.7111 6.88005C28.0011 6.24005 27.0811 5.84005 25.9611 5.66005V4.05005H25.5511H24.3611H23.9711V5.64005C22.8311 5.78005 21.8511 6.18005 21.0511 6.84005C20.1511 7.58005 19.7011 8.59005 19.7011 9.89005C19.7011 10.53 19.8111 11.09 20.0211 11.56C20.2311 12.03 20.5511 12.41 20.9711 12.7C21.3911 12.99 21.8111 13.23 22.2211 13.4C22.6311 13.57 23.1311 13.74 23.7211 13.88C23.8111 13.9 23.8911 13.92 23.9711 13.94V18.15C23.5111 18 23.1111 17.74 22.8011 17.38C22.4011 16.92 22.2011 16.33 22.2211 15.6H19.3711C19.6511 18.57 21.1911 20.22 23.9811 20.56V22.31H24.3711H25.5611H25.9711V20.56C26.5711 20.49 27.1211 20.36 27.6211 20.17C28.2311 19.94 28.7111 19.66 29.0711 19.35C29.4211 19.04 29.7211 18.69 29.9611 18.31C30.2011 17.93 30.3611 17.58 30.4511 17.27C30.5411 16.96 30.5811 16.67 30.5811 16.42C30.5711 16.06 30.5611 15.76 30.5411 15.52ZM22.9711 10.64C22.7011 10.4 22.5611 10.06 22.5611 9.62005C22.5611 9.08005 22.7411 8.67005 23.0911 8.38005C23.3511 8.17005 23.6411 8.04005 23.9711 7.98005V11.12C23.5211 10.99 23.1811 10.83 22.9711 10.64ZM27.0711 17.69C26.7411 17.94 26.3711 18.11 25.9711 18.21V14.54C26.5611 14.72 27.0011 14.92 27.2511 15.14C27.5611 15.41 27.7211 15.8 27.7211 16.31C27.7211 16.89 27.5011 17.36 27.0711 17.69Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandAlone);
export default __webpack_public_path__ + "static/media/StandAlone.8b902df6419338daf90c840dd42c640c.svg";
export { ForwardRef as ReactComponent };